import React, { useEffect, useState } from "react";
import ProductCard from "./ProductCard";
import LoadingScreen from "./LoadingScreen"; // <--- IMPORT THIS
import "./StorePage.css";

function StorePage() {
  const [products, setProducts] = useState([]);
  const [status, setStatus] = useState("loading"); 
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setStatus("loading");
        const res = await fetch("/.netlify/functions/get-products", {
          credentials: "same-origin",
        });
        const data = await res.json(); 
        if (!cancelled) {
          setProducts(Array.isArray(data) ? data : []);
          setStatus("ready");
        }
      } catch (err) {
        if (!cancelled) {
          console.error(err);
          setError("Failed to load products.");
          setStatus("error");
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  // 1. USE LOADING SCREEN HERE
  if (status === "loading") {
    return <LoadingScreen />;
  }

  if (status === "error") {
    return (
      <div className="store-page-container">
        <h1 className="store-title">{error}</h1>
      </div>
    );
  }

  return (
    <div className="store-page-container">
      <h1 className="store-title">The Official Store</h1>

      <div className="store-grid-container">
        {products.map((p) => (
          <ProductCard key={p._id} product={p} view="card" />
        ))}
      </div>
    </div>
  );
}

export default StorePage;